import { createFileRoute } from '@tanstack/react-router';

import { AssemblyCalculationPage } from '@/areas/calculations/ProjectCalculation/CalculationTable/AssemblyCalculationPage';
import { calculationViewModulePermissions, canViewCalculation } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/projects/$projectId/calculation/assemblies/$assemblyId')({
    staticData: {
        access: { permissions: canViewCalculation, modulePermissions: calculationViewModulePermissions },
        chrome: 'project',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    return <AssemblyCalculationPage {...pathParams} />;
}
